<app-base-modal
  [gradientBackground]="'linear-gradient(to bottom, var(--color-sagebrush), var(--color-mossbank))'"
  [hasCustomHeader]="true"
  size="wide"
  (closed)="close()"
>
  <!-- Mascot + category header (x is base-modal's built-in button) -->
  <div header class="nova__header">
    <img
      class="nova__doodat"
      src="assets/nova/nova-mascot.png"
      alt=""
      aria-hidden="true"
    />
    <span class="nova__eyebrow">{{ category }}</span>
  </div>

  <!-- Headline -->
  <h1 class="nova__title">{{ title }}</h1>

  <!-- What Nova noticed -->
  <app-section-card
    class="nova__card"
    variant="small"
    [title]="'what nova noticed'"
    titleColor="var(--color-mossbank)"
    titleFontSize="var(--font-size-body)"
    padding="var(--spacing-4)"
    radius="var(--radius-modal)"
    gap="var(--spacing-2)"
  >
    <p class="nova__body">{{ noticed }}</p>
  </app-section-card>

  <!-- Why this might matter -->
  <app-section-card
    class="nova__card"
    variant="small"
    [title]="'why this might matter'"
    titleColor="var(--color-mossbank)"
    titleFontSize="var(--font-size-body)"
    padding="var(--spacing-4)"
    radius="var(--radius-modal)"
    gap="var(--spacing-2)"
  >
    <p class="nova__body">{{ matters }}</p>
  </app-section-card>

  <!-- A question worth exploring (dark card) -->
  <app-section-card
    class="nova__card"
    variant="small"
    [title]="'a question worth exploring'"
    background="var(--color-evergreen)"
    titleColor="var(--color-sagebrush)"
    titleFontSize="var(--font-size-body)"
    padding="var(--spacing-4)"
    radius="var(--radius-modal)"
    gap="var(--spacing-2)"
  >
    <p class="nova__body nova__body--on-dark">{{ question }}</p>
  </app-section-card>

  <!--
    Bottom CTA - omitted entirely when the card has no action, per FLIP-169 handoff, and equally
    when its label maps to no route (see actionRoute): a button that goes nowhere is worse than none.
  -->
  <app-pill-button
    *ngIf="actionRoute"
    actions
    class="nova__cta"
    [title]="action"
    size="medsmall"
    backgroundColor="var(--color-sagebrush)"
    textColor="var(--color-evergreen)"
    forwardIconColor="var(--color-evergreen)"
    (clicked)="onActionClicked()"
  ></app-pill-button>
</app-base-modal>
